import {
  ContractFilledIcon,
  ContractIcon,
  DnsSettingsIcon,
  LocationFilledIcon,
  PersonLockFilledIcon,
  PersonLockIcon,
  LocationIcon,
  AppsFilledIcon,
  AppsIcon,
  CodeIcon,
  ProductIcon,
  SettingsFilledIcon,
  MobileIcon,
  PrintIcon,
} from '@shopify/polaris-icons';
import { PATHS } from 'src/routes/paths';

export const SETTINGS_MENU_NAME = 'setting';

export function toSettingsKey(menuNameEnglish) {
  return menuNameEnglish.toLowerCase().replace(/\s+/g, '_');
}

export const SETTINGS_ROUTES = {
  users: PATHS.dashboard.settings.users.root,
  locations: PATHS.dashboard.settings.locations.root,
  location_management: PATHS.dashboard.settings.location_management.root,
  packing_materials: PATHS.dashboard.settings.packing_materials.root,
  sorter_management: PATHS.dashboard.settings.sorter_management.root,
  machine: PATHS.dashboard.settings.machine.root,
  manifest_setting: PATHS.dashboard.settings.manifest_setting.root,
  channels: PATHS.dashboard.settings.channels.root,
  mapping_code: PATHS.dashboard.settings.mapping_code,
  invoice_masking: PATHS.dashboard.settings.invoice_masking,
  shipping_item_name: PATHS.dashboard.settings.invoice_masking,
  webhooks: PATHS.dashboard.settings.webhooks,
  suppliers: PATHS.dashboard.settings.supplier.root,
  feature_setting: PATHS.dashboard.settings.feature_setting.root,
  shipper_setting: PATHS.dashboard.settings.shipper_setting.root,
  app_release: PATHS.dashboard.settings.app_release,
};

export const SETTINGS_ICONS = {
  users: { icon: PersonLockFilledIcon, selectedIcon: PersonLockIcon },
  locations: { icon: LocationFilledIcon, selectedIcon: LocationIcon },
  channels: { icon: AppsFilledIcon, selectedIcon: AppsIcon },
  mapping_code: { icon: CodeIcon, selectedIcon: CodeIcon },
  invoice_masking: { icon: ProductIcon, selectedIcon: ProductIcon },
  shipping_item_name: { icon: ProductIcon, selectedIcon: ProductIcon },
  api: { icon: SettingsFilledIcon, selectedIcon: SettingsFilledIcon },
  suppliers: { icon: ContractFilledIcon, selectedIcon: ContractIcon },
  feature_setting: { icon: DnsSettingsIcon, selectedIcon: DnsSettingsIcon },
  shipper_setting: { icon: PersonLockFilledIcon, selectedIcon: PersonLockIcon },
  app_release: { icon: MobileIcon, selectedIcon: MobileIcon },
  printing: { icon: PrintIcon, selectedIcon: PrintIcon },
};

const ADMIN_ONLY_SETTINGS = ['app_release'];

export function filterSettingsMenuByRole(menu, isAdmin) {
  if (isAdmin) return menu;
  return (menu ?? [])
    .filter((item) => !ADMIN_ONLY_SETTINGS.includes(toSettingsKey(item.menuNameEnglish)))
    .map((item) =>
      item.menuChildren?.length
        ? { ...item, menuChildren: filterSettingsMenuByRole(item.menuChildren, isAdmin) }
        : item,
    );
}

export function getFirstSettingsRoute(menu) {
  for (let item of menu ?? []) {
    const route = SETTINGS_ROUTES[toSettingsKey(item.menuNameEnglish)];
    if (route) {
      return route;
    }
    const found = getFirstSettingsRoute(item.menuChildren);
    if (found) {
      return found;
    }
  }
  return null;
}

export function findSettingsMenuItem(menu, key) {
  const keys = Array.isArray(key) ? key : [key];
  for (let item of menu ?? []) {
    if (keys.includes(toSettingsKey(item.menuNameEnglish))) {
      return item;
    }
    const found = findSettingsMenuItem(item.menuChildren, key);
    if (found) {
      return found;
    }
  }
  return null;
}
